import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@/components/ui/select";
import React from "react";
import { GuestGoalOption, GuestGoalOptions } from "@/api/register.ts";

type Props = {
	priorityList: GuestGoalOptions;
	selectedPriority: GuestGoalOption | undefined;
	setSelectedPriority: React.Dispatch<
		React.SetStateAction<GuestGoalOption | undefined>
	>;
};

const PriorityList: React.FC<Props> = ({
	priorityList,
	selectedPriority,
	setSelectedPriority,
}) => {
	function handleSelectChange(value: string) {
		const selectedId = Number(value);
		const priority = priorityList.find((item) => item.id === selectedId);
		setSelectedPriority(priority);
	}

	return (
		<div className="w-full">
			<Select
				value={selectedPriority ? String(selectedPriority.id) : undefined}
				onValueChange={handleSelectChange}
			>
				<SelectTrigger
					data-testid="priority-list-select"
					className="border-primary-200 border w-full rounded-default py-5 text-textLight h-15"
				>
					<SelectValue placeholder="What's your top priority?" />
				</SelectTrigger>
				<SelectContent position="item-aligned">
					{priorityList.map((item) => (
						<SelectItem
							key={item.id}
							value={String(item.id)}
							className="font-medium text-16 text-primary-600"
						>
							{item.name}
						</SelectItem>
					))}
				</SelectContent>
			</Select>
		</div>
	);
};

export default PriorityList;
